import { SendEmailMutation } from "#src/api/Email.ts";
import { useForm } from "#src/components/forms/Form.tsx";
import { InputItem } from "#src/components/inputs/InputItem.tsx";
import InputSelect, {
  InputOption,
} from "#src/components/inputs/InputSelect.tsx";
import { InputText } from "#src/components/inputs/InputText.tsx";
import InputTextarea from "#src/components/inputs/InputTextarea.tsx";
import Modal from "#src/components/modals/Modal.tsx";
import { apiClient } from "#src/stores/Api.tsx";
import { useStore } from "#src/stores/Store.tsx";
import message from "#src/utils/message.tsx";
import { modals, useModal } from "#src/utils/modals.ts";
import { sendEmailVariables } from "#types/code-generator.ts";
import { BorderButton } from "../buttons/BorderButton";

export const ContactOrganizationModal = modals.create(() => {
  const store = useStore();
  const modal = useModal();
  const form = useForm<{
    email: string;
    message: string;
    department: string;
  }>();

  async function send() {
    form.validateFields(async (err, values) => {
      if (err) {
        console.log("errors", err);
        return;
      }

      const body = form.getFieldValue("message");
      let replyTo = form.getFieldValue("email");
      let name = replyTo;
      let html = `
        <p>${replyTo} has a question/message:</p>
        <p>${body}</p>
      `;

      if (store.user) {
        replyTo = store.user.email;
        name = `${store.user.firstName} ${store.user.lastName}`;
        html = `
          <p><a href="https://${store.organization.subdomain}.captyn.com/admin/users/${store.user.id}">${name}</a> (${replyTo}) has a question/message:</p>
          <p>${body}</p>
        `;
      }

      let sendToOrganization = true;
      const additionalEmails = [];

      if (values.department && values.department !== "general") {
        sendToOrganization = false;
        additionalEmails.push(
          store.organization.departments.find((d) => d.id === values.department)
            ?.email
        );
      }

      let subject = `Message from ${name}`;

      const variables: sendEmailVariables = {
        data: {
          users: [],
          additionalEmails,
          sendToOrganization,
          subject,
          replyTo,
          organizationId: store.organization.id,
          html,
        },
      };

      await apiClient(SendEmailMutation, {
        variables,
      });

      modal.hide();

      message.success("Email sent");
    });
  }

  const label = "Question/Message";
  let departmentSelect = <></>;

  if (store.organization.hasDepartments) {
    departmentSelect = (
      <InputItem
        label="Choose where you’d like to send this message"
        name="department"
        rules={[{ required: true, message: "Please select a department" }]}
        form={form}
        initialValue={"general"}
      >
        <InputSelect>
          <InputOption value={"general"}>General Contact</InputOption>
          {store.organization.departments
            .filter((d) => d.email)
            .map((d) => (
              <InputOption key={d.id} value={d.id}>
                {d.title}
              </InputOption>
            ))}
        </InputSelect>
      </InputItem>
    );
  }

  return (
    <Modal
      visible={modal.visible}
      handleCancel={modal.hide}
      afterClose={modal.remove}
      title={`Send ${store.organization?.title} a Message`}
      footer={
        <>
          <BorderButton type="submit" onClick={send}>
            Send
          </BorderButton>
          <BorderButton onClick={modal.hide}>Cancel</BorderButton>
        </>
      }
    >
      {departmentSelect}

      {!store.user && (
        <InputItem
          label="Email"
          name="email"
          rules={[{ required: true, message: "Please enter an email" }]}
          form={form}
        >
          <InputText placeholder="Your email address" type="email" />
        </InputItem>
      )}

      <InputItem
        label={label}
        name="message"
        rules={[{ required: true, message: "Please enter a message" }]}
        form={form}
      >
        <InputTextarea placeholder="Your message" />
      </InputItem>
    </Modal>
  );
});
